/**
 * Created by jonas on 2022-06-15.
 */
import {SimplePresentation, SimplePresentationRunnerController} from "../winpresentation/SimplePresentationRunner";
import {KitchenDramaSushiManiaReelsView} from "../reels/KitchenDramaSushiManiaReelsView";
import {KitchenDramaSushiMania} from "../KitchenDramaSushiMania";
import {gsap} from "gsap";
import {KitchenDramaSushiManiaSound} from "../sound/KitchenDramaSushiManiaSound";

export class DropInPresentation implements SimplePresentation {
    name:string = "DropInPresentation";

    constructor() {}

    shouldRun():boolean {
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});

        //This roughly = a spin duration of 930ms
        let delay = KitchenDramaSushiManiaReelsView.reelDropDelay;

        const padding = KitchenDramaSushiMania.gameFlowController.calculatePaddingDuration(0.4);
        if (padding > 0){
            delay += padding / 4;
        }

        tl.add(KitchenDramaSushiMania.reelView.reelModels[0].dropIn(KitchenDramaSushiMania.model.gameData.reels[0][0]), 0);
        tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.SYMBOLS_LANDING), ">-0.05");


        tl.add(KitchenDramaSushiMania.reelView.reelModels[1].dropIn(KitchenDramaSushiMania.model.gameData.reels[0][1]), delay);
        if (padding > 0.5){
            tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.SYMBOLS_LANDING), ">-0.05");
        }


        tl.add(KitchenDramaSushiMania.reelView.reelModels[2].dropIn(KitchenDramaSushiMania.model.gameData.reels[0][2]), delay * 2);
        tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.SYMBOLS_LANDING), ">-0.05");


        tl.add(KitchenDramaSushiMania.reelView.reelModels[3].dropIn(KitchenDramaSushiMania.model.gameData.reels[0][3]), delay * 3);
        if (padding > 0.5){
            tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.SYMBOLS_LANDING), ">-0.05");
        }


        tl.add(KitchenDramaSushiMania.reelView.reelModels[4].dropIn(KitchenDramaSushiMania.model.gameData.reels[0][4]), delay * 4);
        tl.add(()=>KitchenDramaSushiMania.soundPlayer.playSound(KitchenDramaSushiManiaSound.SYMBOLS_LANDING), ">-0.05");

    }
}